var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5442 27.5814L20.6581 20.6953L13.772 27.5814",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6581 20.6953V36.189",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1024 31.697C36.7815 30.7816 38.1079 29.3331 38.8723 27.5802C39.6367 25.8272 39.7956 23.8696 39.3239 22.0163C38.8522 20.1631 37.7768 18.5196 36.2673 17.3454C34.7579 16.1713 32.9004 15.5332 30.988 15.5319H28.8189C28.2978 13.5164 27.3266 11.6453 25.9783 10.0592C24.63 8.47309 22.9396 7.21328 21.0343 6.37448C19.129 5.53568 17.0584 5.13972 14.9781 5.21637C12.8977 5.29302 10.8618 5.84028 9.02343 6.81701C7.18503 7.79374 5.59198 9.17452 4.36404 10.8555C3.1361 12.5366 2.30522 14.4741 1.93387 16.5225C1.56252 18.5708 1.66037 20.6767 2.22005 22.6818C2.77973 24.6869 3.78668 26.5391 5.1652 28.099",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5442 27.5814L20.6581 20.6953L13.772 27.5814",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ca73c369ecfce6d700adc52eb7538493.svg";
export { ForwardRef as ReactComponent };